/* This is generated code, don't alter */
var IfcGeometricProjectionEnum;
(function (IfcGeometricProjectionEnum) {
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["GRAPH_VIEW"] = 0] = "GRAPH_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["SKETCH_VIEW"] = 1] = "SKETCH_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["MODEL_VIEW"] = 2] = "MODEL_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["PLAN_VIEW"] = 3] = "PLAN_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["REFLECTED_PLAN_VIEW"] = 4] = "REFLECTED_PLAN_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["SECTION_VIEW"] = 5] = "SECTION_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["ELEVATION_VIEW"] = 6] = "ELEVATION_VIEW";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcGeometricProjectionEnum[IfcGeometricProjectionEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcGeometricProjectionEnum || (IfcGeometricProjectionEnum = {}));
const IfcGeometricProjectionEnumCount = 9;
export { IfcGeometricProjectionEnum, IfcGeometricProjectionEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcGeometricProjectionEnum = new Int32Array([20, 9, 2]);
let prefixSumAddressIfcGeometricProjectionEnum = new Uint32Array([0, 13, 25, 46, 60, 72, 85, 96, 112, 124]);
let slotMapIfcGeometricProjectionEnum = new Int32Array([7, 8, 4, 5, 2, 1, 3, 6, 0]);
let encodedDataIfcGeometricProjectionEnum = (new TextEncoder()).encode(".USERDEFINED..NOTDEFINED..REFLECTED_PLAN_VIEW..SECTION_VIEW..MODEL_VIEW..SKETCH_VIEW..PLAN_VIEW..ELEVATION_VIEW..GRAPH_VIEW.");
let IfcGeometricProjectionEnumSearch = new MinimalPerfectHash(gMapIfcGeometricProjectionEnum, prefixSumAddressIfcGeometricProjectionEnum, slotMapIfcGeometricProjectionEnum, encodedDataIfcGeometricProjectionEnum);
export { IfcGeometricProjectionEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcGeometricProjectionEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcGeometricProjectionEnumSearch, input, cursor, endCursor);
}
